<template>
	<a-tabs default-active-key="1" @change="callback">
		<a-tab-pane key="1" tab="采购申请">
			<div class="content_main">
				<div class="content_main_top">
					<a-button type="primary" style="margin-right: 5px" @click="show_apply" :disabled="selectedRowKeysTabItems.length < 1">采购申请</a-button>
					<a-button type="primary" style="margin-right: 5px" @click="Warehousing" v-if="supplementEnable">补充品类</a-button>
					<a-button type="primary" @click="registration" :disabled="selectedRowKeysTabItems.length < 1">采购预登记</a-button>
				</div>
				<div class="content_main_top">
					<a-input placeholder="物品名称" allowClear v-model="name" class="a_input_self margin_self" @keyup.enter.native="serch" />
					<a-input placeholder="物品编号" allowClear v-model="spu_sn" class="a_input_self margin_self" @keyup.enter.native="serch" />
					<!-- <a-range-picker valueFormat="YYYY-MM-DD" allowClear v-model="date" :placeholder="['采购开始', '采购结束']" /> -->
					<a-button type="primary" style="margin: 5px" @click="serch"> 查询 </a-button>
					<a-button type="primary" ghost @click="result"> 重置 </a-button>
				</div>
				<div class="content_main_center_scroll" id="content_main_center_scroll">
					<a-table :data-source="data" bordered :scroll="{ y: scroll_y }" rowKey="id" :row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChangeTab }"
					 :pagination="pagination" @change="handleTableChange">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (pagination.current - 1) * pagination.pageSize + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="company_name" ellipsis="true" title="所属公司" data-index="company_name" />
						<a-table-column key="spu_sn" ellipsis="true" title="物品编号" data-index="spu_sn" />
						<a-table-column key="name" ellipsis="true" title="物品名称" data-index="name" />
						<a-table-column key="model" ellipsis="true" title="规格型号" data-index="model" />
						<a-table-column key="amount" ellipsis="true" title="物品数量" data-index="amount" />
						<a-table-column key="unit" ellipsis="true" title="单位" data-index="unit" />
						<a-table-column key="price" ellipsis="true" title="物品单价" data-index="price" />
						<a-table-column key="is_inspected" title="是否检定" data-index="is_inspected">
							<template slot-scope="text, record">
								{{ instrumentMap[record.is_inspected] }}
							</template>
						</a-table-column>
						<a-table-column key="action" title="操作" data-index="action" width="100">
							<template scope="text,record">
								<a @click="details(record)">详情</a>
								<a-divider type="vertical" />
								<a :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a>
							</template>
						</a-table-column>
					</a-table>
				</div>
				<a-modal v-model="is_apply_show" title="耗材申购-采购新增" width="60%" :maskClosable="false" @cancel="clearDelivery">
					<template slot="footer">
						<a-button key="back" @click="clearDelivery"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="apply_delivery"> 提交 </a-button>
					</template>
					<a-form-model :rules="apply_rules" ref="apply_ref" :model="apply_info" :label-col="labelCol3" :wrapper-col="wrapperCol3">
						<a-row>
							<a-form-model-item label="选择抄送人" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
								<ccChange :data="ccC" @targetKeys="getdata" v-if="isRouterAlive" />
							</a-form-model-item>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="费用归属部门" prop="ascriptionDept" :rules="{
						  required: true,
						  message: '请选择费用归属部门',
						  trigger: 'change',
						}">
									<!-- <a-select allowClear placeholder="请选择" v-model="apply_info.ascriptionDept">
										<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
											{{ item.dept_name }}
										</a-select-option>
									</a-select> -->
									<a-tree-select allowClear :treeData="deptTree" placeholder="请选择" v-model="apply_info.ascriptionDept" treeDefaultExpandAll>
									</a-tree-select>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="采购类型" prop="itemType" :rules="{
						  required: true,
						  message: '请选择采购类型',
						  trigger: 'change',
						}">
									<a-select allowClear placeholder="请选择" v-model="apply_info.itemType">
										<a-select-option :value="item.value" v-for="(item, index) in goodsType" :key="index">
											{{ item.label }}
										</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>

						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="期望交付日期" prop="expectDate" :rules="{
							  required: true,
							  message: '请选择期望交付日期',
							  trigger: 'change',
							}">
									<a-date-picker valueFormat="YYYY-MM-DD" style="width: 364px" :value="apply_info.expectDate" @change="timeChange" />
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="备注">
									<a-input v-model="apply_info.remark" placeholder="请输入"></a-input>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-table :data-source="apply_info.old_goods" bordered :pagination="false">
								<a-table-column key="spu_sn" title="物品编号" ellipsis="true" data-index="spu_sn" v-if="keynum==1" />
								<a-table-column key="spuSn" title="物品编号" ellipsis="true" data-index="spuSn" v-else-if="keynum==2" />
								<a-table-column key="name" title="物品名称" ellipsis="true" data-index="name" />
								<a-table-column key="model" title="规格型号" ellipsis="true" data-index="model" />
								<a-table-column key="is_inspected" title="是否检定" data-index="is_inspected" v-if="keynum==1">
									<template scope="text">
										<span :style="{ color: colors[text] }">
											{{ instrumentMap[text] }}
										</span>
									</template>
								</a-table-column>
								<a-table-column key="isInspected" title="是否检定" data-index="isInspected" v-else-if="keynum==2">
									<template scope="text">
										<span :style="{ color: colors[text] }">
											{{ instrumentMap[text] }}
										</span>
									</template>
								</a-table-column>
								<a-table-column key="price" title="物品单价" ellipsis="true" data-index="price" />
								<a-table-column key="delivery_amount" title="采购数量" data-index="delivery_amount" width="200px">
									<template scope="text,record">
										<a-input type="number" v-model="record.delivery_amount" @blur="set_max_min(record)" />
									</template>
								</a-table-column>
								<a-table-column key="unit" title="单位" ellipsis="true" data-index="unit" />
								<a-table-column key="usages" title="使用部门" data-index="usages" width="200px">
									<template scope="text,record">
										<a-tree-select allowClear multiple :treeData="deptTree" placeholder="请输入" v-model="record.usages"
											 treeDefaultExpandAll>
											</a-tree-select>
										<!-- <a-select allowClear mode="multiple" placeholder="请选择" v-model="record.usages" @change="$forceUpdate()"> -->
											
											<!-- <a-select-option  :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
												{{ item.dept_name }}
											</a-select-option> -->
										<!-- </a-select> -->
									</template>
								</a-table-column>
								<a-table-column key="remark" title="备注" data-index="remark" width="200px">
									<template scope="text,record">
										<a-input v-model="record.remark" />
									</template>
								</a-table-column>
								<a-table-column key="action" title="操作" data-index="action">
									<template scope="text,record,index">
										<a @click="deletes(index)">删除</a>
									</template>
								</a-table-column>
							</a-table>
						</a-row>
					</a-form-model>
				</a-modal>
				<a-modal v-model="is_registration" title="耗材申购-采购预登记" width="80%" :maskClosable="false">
					<template slot="footer">
						<a-button key="back" @click="is_registration = false"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="registration_delivery"> 提交 </a-button>
					</template>
					<a-form-model :rules="apply_rules" ref="apply_ref2" :model="apply_pre" :label-col="labelCol3" :wrapper-col="wrapperCol3">
						<a-row>
							<a-table :data-source="apply_pre.old_goods" bordered :pagination="false">
								<a-table-column key="goodsType" title="登记编号" data-index="goodsType" width="200px">
									<template scope="text,record">
										<a-input v-model="record.goodsType" />
									</template>
								</a-table-column>
								<a-table-column key="spu_sn" title="物品编号" ellipsis="true" data-index="spu_sn" />
								<a-table-column key="name" title="物品名称" ellipsis="true" data-index="name" />
								<a-table-column key="model" title="规格型号" ellipsis="true" data-index="model" />
								<a-table-column key="is_inspected" title="是否检定" data-index="is_inspected">
									<template scope="text">
										<span :style="{ color: colors[text] }">
											{{ instrumentMap[text] }}
										</span>
									</template>
								</a-table-column>
								<a-table-column key="price" title="物品单价" ellipsis="true" data-index="price" />
								<a-table-column key="delivery_amount" title="采购数量" data-index="delivery_amount" width="200px">
									<template scope="text,record">
										<a-input type="number" v-model="record.delivery_amount" @blur="set_max_min(record)" />
									</template>
								</a-table-column>
								<a-table-column key="unit" title="单位" ellipsis="true" data-index="unit" />
								<a-table-column key="usages" title="使用部门" data-index="usages" width="200px">
									<template scope="text,record">
										<a-select allowClear placeholder="请选择" v-model="record.usages" @change="$forceUpdate()">
											<a-select-option :value="item.deptId" v-for="(item, index) in deptlist" :key="index">
												{{ item.title }}
											</a-select-option>
										</a-select>
									</template>
								</a-table-column>
								<a-table-column key="action" title="操作" data-index="action">
									<template scope="text,record,index">
										<a @click="deletes(index)">删除</a>
									</template>
								</a-table-column>
							</a-table>
						</a-row>
					</a-form-model>
				</a-modal>

				<a-modal title="耗材申购-申购详情" :visible="detailsvisible" @cancel="detailsvisible = false" width="55%">
					<template slot="footer">
						<a-button key="back" @click="detailsvisible = false"> 取消 </a-button>
					</template>
					<a-form-model :model="detailsrow" :label-col="labelCol" :wrapper-col="wrapperCol">
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="物品编号">
									<span>{{ detailsrow.spu_sn }}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="物品名称">
									<span>{{ detailsrow.name }}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="规格型号">
									<span>{{ detailsrow.model }}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="物品数量">
									<span>{{ detailsrow.amount }}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="物品单价">
									<span>{{ detailsrow.price }}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="物品单位">
									<span>{{ detailsrow.unit }}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="资产类别">
									<span>{{ detailsrow.spu_type_name }}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="是否已检定">
									<span>{{ instrumentMap[detailsrow.is_inspected] }}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="公司名称">
									<span>{{ detailsrow.company_name }}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="备注">
									<span>{{ detailsrow.notes }}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="是否为制毒、制爆">
									<span><span>{{ detailsrow.hazard_type ? detailsrow.hazard_type.replace('其他;', '').replace(/;/g, '、') : '' }}</span></span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="存放条件">
									<span>{{ detailsrow.storage_cond ? detailsrow.storage_cond.replace('其他;', '').replace(/;/g, '、') : '' }}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
					</a-form-model>
				</a-modal>
				<a-modal title="耗材申购-补充品类" v-model="Warevisible" width="1000px" :maskClosable="false">
					<template slot="footer">
						<a-button key="back" @click="WareCancel"> 取消 </a-button>
						<a-button key="submit" type="primary" @click="Wareprese"> 录入 </a-button>
					</template>
					<a-form :form="form" :labelCol="labelCol3" :wrapperCol="wrapperCol3">
						<a-row>
							<a-col :span="8">
								<a-form-item label="公司名称">
									<a-input allowClear v-decorator="['company_id', { rules: [{ required: true, message: '请填写公司名称!' }] }]"
									 disabled />
								</a-form-item>
							</a-col>
							<a-col :span="8">
								<a-form-item label="品类名称">
									<a-input allowClear v-decorator="['name', { rules: [{ required: true, message: '请填写物品名称!' }] }]" placeholder="请输入物品名称" />
								</a-form-item>
							</a-col>
							<a-col :span="8">
								<a-form-item label="规格型号">
									<a-input allowClear v-decorator="['model', { rules: [{ required: true, message: '请填写规格型号!' }] }]" placeholder="请输入型号或名称" />
								</a-form-item>
							</a-col>
						</a-row>
						<!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物品编号" class="form_item2">
								<a-input allowClear v-decorator="['asset_sn', { rules: [{ required: true, message: '请填写物品编号!' }] }]" disabled />
							</a-form-item> -->
						<a-row>
							<a-col :span="8">
								<a-form-item label="单　　位">
									<a-input allowClear v-decorator="['unit', { rules: [{ required: true, message: '请填写物品单位!' }] }]" placeholder="请输入物品单位" />
								</a-form-item>
							</a-col>
							<a-col :span="8">
								<a-form-item label="类　　别">
									<a-select allowClear v-decorator="['spu_type', { rules: [{ required: true, message: '请填写资产类别!' }] }]"
									 placeholder="请选择">
										<a-select-option :key="index" v-for="(item, index) in assettype" :value="item.dictCode">
											{{ item.dictLabel }}
										</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
							<a-col :span="8">
								<a-form-item label="是否已检定">
									<a-select allowClear v-decorator="['is_inspected', { rules: [{ required: true, message: '请选择是否已检定!' }] }]"
									 placeholder="请选择">
										<a-select-option :key="index" v-for="(item, index) in instrumentMap" :value="index">
											{{ item }}
										</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="8">
								<a-form-item label="备　　注">
									<a-input allowClear v-decorator="['notes']" placeholder="请输入备注" />
								</a-form-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-item label="是否为制毒、制爆">
									<a-checkbox-group v-decorator="['hazard_type', { rules: [{ required: true, message: '请选择!' }] }]" :options="checkout"
									 @change="checkoutChange2" />
									<a-input v-model="elss" style="width: 200px" :disabled="form.getFieldValue('hazard_type') ? form.getFieldValue('hazard_type').indexOf('其他') == -1 : ''" />
								</a-form-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="24">
								<a-form-model-item label="存放条件">
									<a-checkbox-group v-decorator="['storage_cond', { rules: [{ required: true, message: '请选择!' }] }]" :options="condition"
									 @change="conditionChange2" />
									<a-input v-model="others" style="width: 200px" :disabled="
										  form.getFieldValue('storage_cond') ? form.getFieldValue('storage_cond').indexOf('其他') == -1 : ''
										" />
								</a-form-model-item>
							</a-col>
						</a-row>
					</a-form>
				</a-modal>

				<!-- 撤销提示 -->
				<a-modal v-model="is_revocation" title="确认撤销此申请吗?" on-ok="handleOkReason">
					<template slot="footer">
						<a-button key="back" @click="is_revocation = false"> 取消 </a-button>
						<a-button key="submit" type="primary" :loading="loading" @click="handleOkReason"> 撤销 </a-button>
					</template>
					<a-textarea placeholder="请输入原因" v-model="reason" />
				</a-modal>
			</div>
		</a-tab-pane>
		<a-tab-pane key="2" tab="登记记录">
			<div class="content_main">
				<div class="content_main_top">
					<a-button type="primary" style="margin-right: 5px" @click="show_apply" :disabled="selectedRowKeysTabItems.length < 1">采购申请</a-button>
				</div>
				<div class="content_main_top">
					<a-input placeholder="物品名称" allowClear v-model="query.name" class="a_input_self margin_self" @keyup.enter.native="serch2" />
					<a-input placeholder="登记编号" allowClear v-model="query.spu_sn" class="a_input_self margin_self" @keyup.enter.native="serch2" />
					<!-- <a-range-picker valueFormat="YYYY-MM-DD" allowClear v-model="date" :placeholder="['采购开始', '采购结束']" /> -->
					<a-button type="primary" style="margin: 5px" @click="serch2"> 查询 </a-button>
					<a-button type="primary" ghost @click="result2"> 重置 </a-button>
				</div>
				<div class="content_main_center_scroll" id="content_main_center_scroll">
					<a-table :data-source="data2" bordered :scroll="{ y: scroll_y }" rowKey="id" :row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChangeTab }"
					 :pagination="pagination2" @change="handleTableChange2">
						<a-table-column key="index" title="序号" data-index="index" width="70px">
							<template scope="text, record, index">{{ (pagination2.current - 1) * pagination2.pageSize + index + 1 }}</template>
						</a-table-column>
						<a-table-column key="goodsType" ellipsis="true" title="登记编号" data-index="goodsType" />
						<a-table-column key="spuSn" ellipsis="true" title="物品编号" data-index="spuSn" />
						<a-table-column key="name" ellipsis="true" title="物品名称" data-index="name" />
						<a-table-column key="model" ellipsis="true" title="规格型号" data-index="model" />
						<a-table-column key="amount" ellipsis="true" title="采购数量" data-index="amount" />
						<a-table-column key="unit" ellipsis="true" title="单位" data-index="unit" />
						<a-table-column key="price" ellipsis="true" title="物品单价" data-index="price" />
						<a-table-column key="isInspected" title="是否检定" data-index="isInspected">
							<template slot-scope="text, record">
								{{ instrumentMap[record.isInspected] }}
							</template>
						</a-table-column>
						<a-table-column key="createTime" ellipsis="true" title="录入时间" data-index="createTime" />
						<a-table-column key="action" title="操作" data-index="action" width="100">
							<template scope="text,record">
								<a @click="goods_update(record)">编辑</a>
								<a-divider type="vertical" />
								<a @click="goods_delete(record)">删除</a>
							</template>
						</a-table-column>
					</a-table>
				</div>
			</div>
			<a-modal title="耗材申购-编辑" :visible="goods_update_visible" @ok="editOk" @cancel="goods_update_visible=false" width="880px"
			 :maskClosable="false">
				<template slot="footer">
					<a-button key="back" @click="goods_update_visible=false"> 取消 </a-button>
					<a-button type="primary" @click="editOk"> 保存 </a-button>
				</template>
				<a-form-model ref="ruleForm" :rules="rules" :model="updaterow" :labelCol="labelCol4" :wrapperCol="wrapperCol4">
					<a-row>
						<a-col :span="12">
							<a-form-model-item label="登记编号">
								<a-input allowClear v-model="updaterow.goodsType" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
						<a-col :span="12">
							<a-form-model-item label="物品编号">
								<a-input allowClear disabled v-model="updaterow.spuSn" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="12">
							<a-form-model-item label="物品名称">
								<a-input allowClear disabled v-model="updaterow.name" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
						<a-col :span="12">
							<a-form-model-item label="规格型号">
								<a-input allowClear disabled v-model="updaterow.model" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="12">
							<a-form-model-item label="是否检定">
								<a-select disabled v-model="updaterow.isInspected" placeholder="请选择">
									<a-select-option :key="index" v-for="(item, index) in instrumentMap" :value="index">
										{{ item }}
									</a-select-option>
								</a-select>
							</a-form-model-item>
						</a-col>
						<a-col :span="12">
							<a-form-model-item label="物品单价">
								<a-input allowClear disabled v-model="updaterow.price" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="12">
							<a-form-model-item label="采购数量">
								<a-input allowClear v-model="updaterow.amount" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
						<a-col :span="12">
							<a-form-model-item label="单位">
								<a-input allowClear disabled v-model="updaterow.unit" placeholder="请输入" />
							</a-form-model-item>
						</a-col>
					</a-row>
					<a-row>
						<a-col :span="12">
							<a-form-model-item label="使用部门">
								<!-- <a-select allowClear >
									<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
										{{ item.dept_name }}
									</a-select-option>
								</a-select> -->
								<a-tree-select allowClear :treeData="deptTree" placeholder="请选择" v-model="updaterow.usages" treeDefaultExpandAll>
								</a-tree-select>
							</a-form-model-item>
						</a-col>
					</a-row>
				</a-form-model>
			</a-modal>

		</a-tab-pane>
	</a-tabs>
</template>

<script>
	import debounce from 'lodash/debounce'
	import {
		getDeptListEnable2
	} from '@/api/system'
	import {
		purchase_save,
		anticipate_goods,
		anticipate_goods_listall,
		anticipate_goods_update,
		anticipate_goods_delete,
		tree_all
	} from '@/api/purchase'
	import {
		claim_apply,
		consumablesList,
		dict,
		// spu_add,
		addConsumables
	} from '@/api/assetmenag'
	import {
		delProcessIns,
	} from '@/api/activiti'
	import {
		get_dict,
		returnDept2,
		get_users
	} from '@/utils/unit_axios'
	import {
		checkPermission
	} from '@/utils/permissions'
	import {
		ACCESS_TOKEN
	} from '@/store/mutation-types'
	import ccChange from '@/components/module/ccChange'
	import storage from 'store'
	const deptMap = {}
	const checkout = ['易制毒', '易制爆', '剧毒', '其他']
	const condition = ['常温', '冷冻', '冷藏', '避光', '其他']
	export default {
		data() {
			return {
				query: {
					spu_sn: '',
					name: '',
				},
				checkout,
				condition,
				deptTree:[],
				updaterow: '',
				Warevisible: false,
				is_registration: false,
				is_revocation: false,
				operTypeMap: {},
				ids: '', //撤销id
				reason: '', //撤销原因
				statusMap: '',
				isRouterAlive: true,
				selectedRowKeysTab: [],
				selectedRowKeysTabItems: [],
				scroll_y: 150,
				deptMap,
				data: '',
				data2: '',
				loading: false,
				name: '', //搜索关键字
				spu_sn: '',
				date: [],
				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				pagination2: {
					current: 1,
					pageSize: 10,
					total: 0,
					pageSizeOptions: ['10', '20', '30', '40', '50'],
					showLessItems: true,
					showSizeChanger: true,
				},
				apply_rules: {
					reason: [{
						required: true,
						message: '请输入申领原因',
						trigger: 'blur',
					}, ],
				},
				is_apply_show: false,
				apply_info: {
					cc: [],
					expectDate: '',
					ascriptionDept: undefined,
					itemType: undefined,
					remark: '',
					old_goods: [],
				},
				apply_pre: {
					old_goods: [],
				},
				form: this.$form.createForm(this),
				labelCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 7,
					},
				},
				wrapperCol: {
					xs: {
						span: 24,
					},
					sm: {
						span: 16,
					},
				},
				labelCol2: {
					span: 2
				},
				wrapperCol2: {
					span: 22
				},
				labelCol3: {
					span: 8
				},
				wrapperCol3: {
					span: 16
				},
				labelCol4: {
					span: 6
				},
				wrapperCol4: {
					span: 18
				},
				checkList: [],
				checkList2: [],
				els: '',
				other: '',
				elss: '',
				others: '',
				options: [],
				checkAll: false,
				indeterminate: false,
				checkAllOptions: [], //全项
				detailsrow: '',
				detailsvisible: false,
				ccC: 'purchase',
				companylist: [],
				deptlist: [],
				keynum: '',
				goods_update_visible: false,
				supplementEnable: checkPermission('purchase:list:supplement'), //补充品类
				times: null
			}
		},
		components: {
			ccChange
		},
		filters: {
			operTypeFilter(type) {
				return operTypeMap[type].text
			},
			deptFilter(type) {
				return deptMap[type].text
			},
		},
		created() {
			this.get_list()
			this.get_list2()
			tree_all().then((res) => {
				this.companylist = res.data[0]
				this.companylist.unshift({
					deptid: 0,
					title: '所有公司',
					children: [],
				})
			})
			get_dict('goodStatus', (res) => {
				this.statusMap = res
			})
			dict({
				pageNum: 1,
				pageSize: 10,
				dictType: 'assets_type',
			}).then((res) => {
				this.assettype = res.rows
				this.assettype.map((d) => {
					this.operTypeMap[d.dictCode] = {
						text: d.dictLabel,
					}
				})
			})
		},
		mounted() {
			returnDept2((res) => {
				this.options = res.depts
			})
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 120
				}, 1000)
			})
		},
		 beforeDestroy(){
            clearTimeout(this.times);
          },
		methods: {
			editOk() {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						anticipate_goods_update(this.updaterow)
							.then((res) => {
								if (res.code == 200) {
									this.goods_update_visible = false
									this.$message.success('编辑成功')
									this.get_list2()
								} else {
									this.$message.success(res.msg)
								}
							})
							.catch(() => {
								this.$message.error('系统错误，请稍后再试')
							})
					} else {
						return false
					}
				})
			},
			goods_update(row) {
				this.companylist.forEach((item) => {
					if (item.deptId == this.$store.getters.userInfo.companyId) {
						this.deptlist = item.children
					}
				})
				this.goods_update_visible = true
				var rows = row
				let resData = {}
				for (let key in rows) {
					resData[key] = rows[key]
					resData['isInspected'] = rows['isInspected'] + ''
				}
				this.updaterow = resData
			},
			goods_delete(row) {
				anticipate_goods_delete([row.id]).then(res => {
					if (res.code != 200) {
						this.$message.error(res.msg)
						return
					}
					this.$message.success('删除成功')
					this.get_list2()
				})
			},
			callback(key) {
				this.keynum = key
				this.selectedRowKeysTab = []
				this.selectedRowKeysTabItems = []
				if (key == 1) {
					this.get_list()
				} else if (key == 2) {
					this.get_list2()
				}
			},
			Wareprese() {
				this.form.validateFields((err, values) => {
					if (!err) {
						if (values['hazard_type']) {
							if (values['hazard_type'].indexOf('其他') > -1) {
								if (this.elss == '') {
									this.elss = '无'
								}
								values['hazard_type'] = this.checkList.join(';') + ';' + this.elss
							} else {
								values['hazard_type'] = this.checkList.join(';')
							}
						}
						if (values['storage_cond']) {
							if (values['storage_cond'].indexOf('其他') > -1) {
								if (this.others == '') {
									this.others = '无'
								}
								values['storage_cond'] = this.checkList2.join(';') + ';' + this.others
							} else {
								values['storage_cond'] = this.checkList2.join(';')
							}
						}
						this.companylist.forEach(item => {
							if (item.title == values['company_id']) {
								values['company_id'] = item.deptId
							}
						})
						var value = values
						let resData = {}
						for (let key in value) {
							resData[key] = value[key]
							resData['create_by'] = this.$store.getters.userInfo.userName
							resData['company_id'] = this.$store.getters.userInfo.companyId
							if (key == 'price' || key == 'value' || key == 'amount') {
								resData[key] = value[key]
							}
						}
						// spu_add
							var data = {
					companyId: resData.company_id,
					createBy: resData.create_by,
					hazardType: resData.hazard_type,
					isInspected: resData.is_inspected,
					model: resData.model,
					name: resData.name,
					notes: resData.notes,
					spuType: resData.spu_type,
					storageCond: resData.storage_cond,
					unit: resData.unit,
				}
						addConsumables(data)
							.then((res) => {
								if (res.code === 200) {
									this.$message.success('保存成功')
									this.$emit('ok')
									this.Warevisible = false
									this.form.resetFields()
									this.elss = ''
									this.others = ''
									this.get_list()
								} else {
									this.$message.success(res.msg)
								}
							})
							.catch(() => {
								this.$message.error('系统错误，请稍后再试')
							})
					}
				})
			},
			WareCancel() {
				this.Warevisible = false
			},
			checkoutChange2(checkedList) {
				if (checkedList.indexOf('其他') == -1) {
					this.elss = ''
				}
				this.checkList = checkedList
			},
			conditionChange2(checkedList) {
				if (checkedList.indexOf('其他') == -1) {
					this.others = ''
				}
				this.checkList2 = checkedList
			},
			Warehousing() {
				this.Warevisible = true
				this.form.resetFields()
				this.$nextTick(() => {
					this.form.setFieldsValue({
						company_id: this.$store.getters.userInfo.company
					})
				})
			},
			//限制最大值
			set_max_min(row) {
				let max = row.amount
				if (row.delivery_amount < 1) {
					row.delivery_amount = 1
				}
				this.$forceUpdate()
			},
			timeChange(date) {
				this.apply_info.expectDate = date
				console.log(this.apply_info.expectDate)
			},
			deletes(index) {
				this.selectedRowKeysTab.splice(index, 1)
				this.selectedRowKeysTabItems.splice(index, 1)
			},
			result() {
				this.spu_sn = ''
				this.name = ''
			},
			result2() {
				this.query.spu_sn = ''
				this.query.name = ''
			},
			// 撤销
			cancel(ids) {
				this.is_revocation = true
				this.ids = ids
				this.reason = ''
			},
			//撤销提交
			handleOkReason() {
				delProcessIns({
					ids: this.ids.join(','),
					reason: this.reason,
				}).then((res) => {
					if (res.code === 200) {
						this.$message.success('撤销成功')
						this.get_list()
						this.is_revocation = false
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			getdata(data) {
				this.apply_info.cc = data
			},
			//搜索
			serch() {
				this.loading = true
				this.pagination.current = 1
				this.get_list()
			},
			serch2() {
				this.loading = true
				this.pagination2.current = 1
				this.get_list2()
			},
			//改变分页
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current
				this.pagination.pageSize = pagination.pageSize
				this.get_list()
			},
			handleTableChange2(pagination, filters, sorter) {
				this.pagination2.current = pagination.current
				this.pagination2.pageSize = pagination.pageSize
				this.get_list2()
			},
			get_list() {
				this.loading = true
				// sku_spu
				consumablesList({
					pageSize: this.pagination.pageSize,
					pageIndex: this.pagination.current,
					name: this.name,
					spuSn: this.spu_sn,
					sortField: 'id',
					sortOrder: 'desc' 
				}).then((res) => {
					var arry = []
					res.data.list.forEach(item => {
						var a = {}
						a = {
							amount: item.storageNum,
							average_price: item.averagePrice,
						    company_id: item.companyId,
						    company_name: item.companyName,
							createBy: item.createBy,
							createTime: item.createTime,
							dept_id: item.deptId,
							hazard_type: item.hazardType,
							id: item.id,
							is_inspected: item.isInspected,
							is_inspected_name: item.isInspectedName,
							model: item.model,
							name: item.name,
							notes: item.notes,
							period: item.period,
							price: item.price,
							short_limit: item.shortLimit,
							spu_sn: item.spuSn,
							spu_type: item.spuType,
							spu_type_name: item.spuTypeName,
							storage_cond: item.storageCond,
							// storage_num: item.storageNum,
							unit: item.unit,
							updateBy: item.updateBy,
							updateTime: item.updateTime

						}
						arry.push(a)
					})
					this.loading = false
					const pagination = { ...this.pagination
					}
					pagination.total = res.data.totalCount
					this.pagination = pagination
					this.data = arry
					// this.data.forEach((item) => {
					// 	item.price = item.price / 100
					// 	item.value = item.value / 100
					// 	item.amount = item.amount / 100
					// })
				})
			},
			get_list2() {
				this.loading = true
				anticipate_goods_listall({
					page_size: this.pagination2.pageSize,
					page_num: this.pagination2.current,
					assetType: 1,
					name: this.query.name,
					goodsType: this.query.spu_sn,
				}).then((res) => {
					this.loading = false
					const pagination = { ...this.pagination2
					}
					pagination.total = res.total
					this.pagination2 = pagination
					this.data2 = res.rows
				})
			},
			//选择第一个表格
			onSelectChangeTab(selectedRowKeys, selectedRows) {
				var arr = JSON.parse(JSON.stringify(selectedRows))
				this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.concat(arr)
				this.selectedRowKeysTab = selectedRowKeys
				var obj = {}
				this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.reduce(function(item, next) {
					obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
					return item
				}, [])
				var newLis = []
				this.selectedRowKeysTab.forEach((key, idx) => {
					this.selectedRowKeysTabItems.forEach((item, index) => {
						if (key == item.id) {
							newLis.push(item)
						}
					})
				})
				this.selectedRowKeysTabItems = newLis
			},
			registration() {
				this.apply_pre = {
					old_goods: [],
				}
				this.companylist.forEach((item) => {
					if (item.deptId == this.$store.getters.userInfo.companyId) {
						this.deptlist = item.children
					}
				})
				this.selectedRowKeysTabItems.forEach((item) => {
					item['goodsType'] = ''
					item['delivery_amount'] = 1
					item['usages'] = undefined
				})
				this.apply_pre.old_goods = this.selectedRowKeysTabItems
				this.is_registration = true
			},
			show_apply() {
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
				this.apply_info = {
					cc: [],
					expectDate: '',
					ascriptionDept: undefined,
					itemType: undefined,
					remark: '',
					old_goods: [],
				}
				this.companylist.forEach((item) => {
					if (item.deptId == this.$store.getters.userInfo.companyId) {
						this.deptlist = item.children
					}
				})
				this.$nextTick(()=>{
					getDeptListEnable2().then((res) => {
						const data = res.rows
						if (data.length > 0) {
							const min = Math.min(...data.map((m) => m.parentId))
							this.buildtree2(data, this.deptTree, this.$store.getters.userInfo.companyId)
						}
					})
				})
				if (this.keynum == 1) {
					this.selectedRowKeysTabItems.forEach((item) => {
						item['delivery_amount'] = 1
						item['usages'] = undefined
					})
				} else if (this.keynum == 2) {
					this.selectedRowKeysTabItems.forEach((item) => {
						item['delivery_amount'] = item['amount']
						item['usages'] = item['usages']
					})
				}
				this.apply_info.old_goods = this.selectedRowKeysTabItems
				this.is_apply_show = true
			},
			buildtree2(list, arr, parentId) {
				list.forEach((item) => {
					if (item.parentId === parentId) {
						var child = {
							key: item.deptId,
							value: item.deptId, // value是给modal的select用的，2者属性不一样
							title: item.deptName,
							scopedSlots: {
								title: 'title',
							},
							children: [],
						}
						this.buildtree2(list, child.children, item.deptId)
						if (child.children.length === 0) {
							delete child.children
						}
						arr.push(child)
					}
				})
			},
			//选择部门
			onChangeDept(value) {
				this.apply_info.cc = []
				this.checkAll = false
				this.apply_info.deptKey = value[1]
				get_users(value[1], (res) => {
					res.forEach((item) => {
						item['label'] = item.userName
						item['value'] = item.userId
					})
					this.checkAllOptions = res
				})
			},
			//全选改变
			onCheckAllChange(e) {
				var vs = []
				this.checkAllOptions.forEach((item) => {
					vs.push(item.value)
				})
				this.apply_info.cc = e.target.checked ? vs : []
				this.indeterminate = false
				this.checkAll = e.target.checked
			},
			// 某项改变
			onChangeFroup(checkedList) {
				this.indeterminate = !!checkedList.length && checkedList.length < this.checkAllOptions.length
				this.checkAll = checkedList.length === this.checkAllOptions.length
			},
			registration_delivery: debounce(function() {
				var _this = this
				this.$refs.apply_ref2.validate((valid) => {
					if (valid) {
						console.log(_this.apply_pre.old_goods, 1212)
						var bizAnticipateGoods = []
						_this.apply_pre.old_goods.forEach(item => {
							bizAnticipateGoods.push({
								goodsType: item.goodsType,
								spuSn: item.spu_sn,
								name: item.name,
								model: item.model,
								isInspected: item.is_inspected,
								price: item.price,
								unit: item.unit,
								usages: item.usages,
								amount: item.delivery_amount,
								spuId: item.id,
								goodType: 1,
								assetType: 1
							})
						})
						anticipate_goods(
							bizAnticipateGoods
						).then((res) => {
							if (res.code != 200) {
								this.$message.error(res.msg)
								return
							}
							this.$message.success('采购预登记成功')
							this.get_list()
							this.is_registration = false
						})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			}, 1000, {
				'leading': true,
				'trailing': false
			}),


			// 取消新增采购事件
			clearDelivery() {
				this.$nextTick(() => {
                //   this.$refs.apply_ref.clearValidate()
                //   this.$refs.apply_ref.resetFields()
				  this.is_apply_show = false
                })
			
			},
			//点击领用出库
			apply_delivery: debounce(function() {
				var _this = this
				this.$refs.apply_ref.validate((valid) => {
					if (valid) {
						var lis = []
						_this.apply_info.old_goods.forEach(item => {
							if (this.keynum == 2) {
								lis.push({
									anticipateGoodsId: item.id,
									spuSn: item.spu_sn,
									name: item.name,
									model: item.model,
									isInspected: item.is_inspected,
									price: item.price,
									unit: item.unit,
									usages: item.usages.toString(),
									amount: item.delivery_amount,
									spuId: item.spuId,
									expectDate: _this.apply_info.expectDate,
									itemType: _this.apply_info.itemType,
									ascriptionDept: _this.apply_info.ascriptionDept,
									goodType: 1
								})
								// this.lis.usages = lis.usages.toString()
							} else {
								lis.push({
									spuSn: item.spu_sn,
									name: item.name,
									model: item.model,
									isInspected: item.is_inspected,
									price: item.price,
									unit: item.unit,
									usages: item.usages.toString(),
									amount: item.delivery_amount,
									spuId: item.id,
									remark:item.remark,
									expectDate: _this.apply_info.expectDate,
									itemType: _this.apply_info.itemType,
									ascriptionDept: _this.apply_info.ascriptionDept,
									goodType: 1
								})
								// this.lis.usages = lis.usages.toString()
							}

						})
						   if(_this.times){
                            clearTimeout(_this.times)
							console.log(_this.times, '_this.times_this.times_this.times_this.times1111111111111111111111111111111111')
                           }
                         _this.times = setTimeout(() => {
							console.log(_this.times, '_this.times_this.times_this.times_this.times222222222222222222222222222222222222222')
                         //调用接口
                         

						purchase_save({
							cc: _this.apply_info.cc.length ? _this.apply_info.cc.join(',') : '',
							bizGoodsInfos: lis,
							remark: _this.apply_info.remark
						}).then((res) => {
							if (res.code != 200) {
								// this.$refs.applyDeliveryRef.clearValidate()
                                // this.$refs.applyDeliveryRef.resetFields()
								this.$message.error(res.msg)
								return
							}
							this.$message.success('采购成功')
							this.get_list()
							this.get_list2()
							this.is_apply_show = false
							this.selectedRowKeysTab = []
							this.selectedRowKeysTabItems = []
						})
					  }, 500)

					} else {
						console.log('error submit!!')
						return false
					}

				})
			}, 1000, {
				'leading': true,
				'trailing': false
			}),
			details(row) {
				this.detailsvisible = true
				this.detailsrow = row
			},
		},


	}
</script>

<style>
	.dialog {
		display: flex;
		justify-content: space-between;
	}

	.flex {
		display: flex;
	}

	.center {
		text-align: center;
		width: 832px;
	}

	.dialog .dialog_item {
		margin-bottom: 5px;
		width: 220px;
		display: flex;
		justify-content: space-between;
	}

	.Exhi {
		display: inline-block;
		border: 1px solid black;
		width: 100px;
		text-align: left;
		color: steelblue;
	}
</style>
